import groq from 'groq'

import { modulesFragment } from './modules'
import { siteFragment } from './site'
import { blogPostWithoutBodyFragment } from './blog'

export const allSlugsQuery = groq`
  *[
    _type == $type &&
    type != "template"
  ] {
    locale,
    "slug": slug.current
  }
`

export const sitemapPagesQuery = groq`
  *[
    _type == $type &&
    locale in $locales &&
    noIndex != true &&
    type != "template"
  ] {
    _type,
    locale,
    "slug": slug.current
  }
`

export const sitemapStaticPagesQuery = groq`
  *[
    _type in $types &&
    locale in $locales &&
    noIndex != true
  ] {
    _type,
    locale
  }
`

export const homePageQuery = groq`
  {
    "page": *[
      _type == "homePage" &&
      locale == $locale
    ] | order(_updatedAt desc)[0] {
      modules[] {
        ${modulesFragment}
      },
      hasTransparentHeader,
      headerBackgroundColor,
      seo,
      noIndex
    },
    "site": {
      ${siteFragment}
    }
  }
`

export const homePageModuleQuery = groq`
  *[
    _type == "homePage" &&
    locale == $locale
  ]
    | order(_updatedAt desc)
  [0].modules[] {
    ${modulesFragment}
  }
`

export const errorPageQuery = groq`
  {
    "page": *[
      _type == "errorPage" &&
      locale == $locale
    ] | order(_updatedAt desc)[0] {
      modules[] {
        ${modulesFragment}
      },
      seo,
      noIndex
    },
    "site": {
      ${siteFragment}
    }
  }
`

export const errorPageModuleQuery = groq`
  *[
    _type == "errorPage" &&
    locale == $locale
  ]
    | order(_updatedAt desc)
  [0].modules[] {
    ${modulesFragment}
  }
`

export const pageQuery = groq`
  {
    "page": *[
      _type == "page" &&
      slug.current in $pageSlugs &&
      locale == $locale
    ] | order(_updatedAt desc)[0] {
      modules[] {
        ${modulesFragment}
      },
      type,
      hasTransparentHeader,
      headerBackgroundColor,
      seo,
      noIndex
    },
    "site": {
      ${siteFragment}
    }
  }
`

export const customPageModuleQuery = groq`
  *[
    _type == "page" &&
    slug.current in $pageSlugs &&
    locale == $locale
  ]
    | order(_updatedAt desc)
  [0].modules[] {
    ${modulesFragment}
  }
`

export const casePageQuery = groq`
  {
    "page": *[
      _type == "case" &&
      slug.current == $caseSlug &&
      locale == $locale
    ] | order(_updatedAt desc)[0] {
      modules[] {
        ${modulesFragment}
      },
      type,
      hasTransparentHeader,
      headerBackgroundColor,
      seo,
      noIndex
    },
    "site": {
      ${siteFragment}
    }
  }
`

export const casePageModuleQuery = groq`
  *[
    _type == "case" &&
    slug.current == $caseSlug &&
    locale == $locale
  ]
    | order(_updatedAt desc)
  [0].modules[] {
    ${modulesFragment}
  }
`

export const blogPostPageQuery = groq`
  {
    "page": *[
      _type == "blogPost" &&
      type != "template" &&
      slug.current == $blogPostSlug &&
      locale == $blogLocale
    ] | order(_updatedAt desc)[0] {
      type,
      hasTransparentHeader,
      headerBackgroundColor,
      seo,
      noIndex,
      modules[] {
        ${modulesFragment}
      },
      "slug": slug.current,
      ${blogPostWithoutBodyFragment}
    },
    "site": {
      ${siteFragment}
    }
  }
`

export const blogPostPageModuleQuery = groq`
  *[
    _type == "blogPost" &&
    type != "template" &&
    slug.current == $blogPostSlug &&
    locale == $blogLocale
  ]
    | order(_updatedAt desc)
  [0].modules[] {
    ${modulesFragment}
  }
`

export const blogPageQuery = groq`
  {
    "page": *[
      _type == "blogPage" &&
      locale == $blogLocale
    ] | order(_updatedAt desc)[0] {
      hasTransparentHeader,
      headerBackgroundColor,
      seo,
      noIndex,
      modules[] {
        ${modulesFragment}
      },
      "posts": *[
        _type == "blogPost" &&
        type != "template" &&
        locale == ^.locale &&
        (!defined(^.author) || author->slug.current == ^.author->slug.current) &&
        (!defined(^.category) || categories[]->slug.current match ^.category->slug.current)
      ] | order(date desc) | order(_createdAt desc) {
        ${blogPostWithoutBodyFragment}
      },
    },
    "site": {
      ${siteFragment}
    }
  }
`

export const blogPageModuleQuery = groq`
  *[
    _type == "blogPage" &&
    locale == $blogLocale
  ]
    | order(_updatedAt desc)
  [0].modules[] {
    ${modulesFragment}
  }
`

export const blogCategoryPageQuery = groq`
  {
    "page": *[
      _type == "blogCategory" &&
      slug.current == $blogCategorySlug &&
      locale == $blogLocale
    ] | order(_updatedAt desc)[0] {
      hasTransparentHeader,
      headerBackgroundColor,
      seo,
      noIndex,
      modules[] {
        ${modulesFragment}
      },
      "slug": slug.current,
      "posts": *[
        _type == "blogPost" &&
        type != "template" &&
        locale == ^.locale &&
        categories[]->slug.current match ^.slug.current
      ] | order(date desc) | order(_createdAt desc) {
        ${blogPostWithoutBodyFragment}
      }
    },
    "site": {
      ${siteFragment}
    }
  }
`

export const blogCategoryPageModuleQuery = groq`
  *[
    _type == "blogCategory" &&
    slug.current == $blogCategorySlug &&
    locale == $blogLocale
  ]
    | order(_updatedAt desc)
  [0].modules[] {
    ${modulesFragment}
  }
`

export const blogAuthorPageQuery = groq`
  {
    "page": *[
      _type == "blogAuthor" &&
      slug.current == $blogAuthorSlug &&
      locale == $blogLocale
    ] | order(_updatedAt desc)[0] {
      hasTransparentHeader,
      headerBackgroundColor,
      seo,
      noIndex,
      modules[] {
        ${modulesFragment}
      },
      "slug": slug.current,
      "posts": *[
        _type == "blogPost" &&
        type != "template" &&
        locale == ^.locale &&
        author->slug.current == ^.slug.current
      ] | order(date desc) | order(_createdAt desc) {
        ${blogPostWithoutBodyFragment}
      }
    },
    "site": {
      ${siteFragment}
    }
  }
`

export const blogAuthorPageModuleQuery = groq`
  *[
    _type == "blogAuthor" &&
    slug.current == $blogAuthorSlug &&
    locale == $blogLocale
  ]
    | order(_updatedAt desc)
  [0].modules[] {
    ${modulesFragment}
  }
`
